/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_User_Password_SuccessInputs */

const vi_toast_user_password_success = /** @type {(inputs: Toast_User_Password_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi mật khẩu thành công`)
};

/**

* @param {Toast_User_Password_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_user_password_success = /** @type {((inputs?: Toast_User_Password_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_User_Password_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_user_password_success(inputs)
});